/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import '../../styles/DeviceDeployment.css';
// Компоненты пользовательского интерфейса
import CustomButton from '../CustomElements/CustomButton';
import Selector from '../CustomElements/Selector';
import DateSelector from '../CustomElements/DateSelector';
import CustomTitle from '../CustomElements/CustomTitle';
import Input from '../CustomElements/Input';
import FormContainer from '../CustomElements/FormContainer';
import CustomContainer from '../CustomElements/CustomContainer';
import Checkbox from '../CustomElements/Checkbox';
import FilePicker from '../FileManager/FilePicker';
// Кастомные хуки
import { useButtonValidation } from '../../customHook/useButtonValidation';
import useOptionsLoader from '../../customHook/useOptionsLoader';
import useSuccessListener from '../../customHook/useSuccessListener';
// Утилиты
import { convertToDate, transformFieldsToMoscowStart } from '../../utils/convertToDate';
import { handleUniversalChange } from '../../utils/formUtils';
// Действия Redux
import { load } from '../../redux/actions/loader.action';
import { transferDeviceForOperation } from '../../redux/actions/devices.action';
import { initOptionsFromServer } from '../../redux/actions/options.action';
import {
  initDepartmentOptionsFromServer,
  initOptionsDirectoratesUippsFromServer,
} from '../../redux/actions/options.action';
import { omitFields } from '../../utils/omitFields';
import { removeEmptyStrings } from '../../utils/removeEmptyStrings';
import { convertStringValuesToNumbers } from '../../utils/convertStringValuesToNumbers';

// компонент выдачи уиппс в эксплуатацию

function TransferUippsToUsage({ currentDevice, closeModal, t }) {
  // Получение функции dispatch для отправки действий в Redux store.
  const dispatch = useDispatch();

  // получаем опции из стора
  const optionsForSelect = useSelector((state) => state.options);
  const { roads, departments } = useSelector((state) => state.options);

  // Состояние для формы
  // Мемоизируем начальные данные формы
  const initialFormData = useMemo(
    () => ({
      deviceId: currentDevice?.id,
      typeId: currentDevice?.typeId,
      date: '',
      acceptanceCert: '',
      roadId: '',
      directorateId: '',
      departmentId: '',
      trainTypeId: '',
      trainNumber: '',
      responsibleId: '',
      responsibleContact: '',
    }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentDevice]
  );

  const [isVisible, setIsVisible] = useState(true);
  const [formData, setFormData] = useState(initialFormData);
  const [optionalFields] = useState(['responsibleId', 'responsibleContact', 'trainTypeId', 'trainNumber']);

  // Функция для обработки события изменения checkbox
  const handleChangeCheckbox = () => setIsVisible((prev) => !prev);

  /** Функция для проверки валидности формы */
  const isButtonDisabled = useButtonValidation(formData, optionalFields);

  // Обработчик отправки формы
  const handlerSubmit = (event) => {
    event.preventDefault();
    //переводим в состояние загрузки
    dispatch(load());
    // Удаляем поля, которые не нужно отправлять
    const formWithoutExcluded = omitFields(formData, ['deviceId', 'acceptanceCertName', 'roadId', 'directorateId']);
    // Удаляем пустые строки
    const formWithoutEmptyStrings = removeEmptyStrings(formWithoutExcluded);
    const transformedPayload = convertStringValuesToNumbers(formWithoutEmptyStrings, ['responsibleId']);
    // Преобразуем указанные поля в начало дня по Москве
    const payload = transformFieldsToMoscowStart(transformedPayload, ['date']);
    // Отправляем данные на сервер через Redux
    dispatch(
      transferDeviceForOperation({
        payload: { ...payload, placement: !isVisible },
        deviceId: formData?.deviceId,
        typeId: formData?.typeId,
        isUipps: true,
        path: 'usage',
      })
    );
  };

  //хук для запроса опций для дирекций и контроля селекта
  const messageForSelectDirectorates = t?.messageForSelectDirectorates || 'Выберите дорогу';
  const directoratesControl = useOptionsLoader(
    formData,
    setFormData,
    ['directorateId', 'departmentId'],
    'roadId',
    initOptionsDirectoratesUippsFromServer,
    messageForSelectDirectorates
  );
  //хук для запроса опций для подразделений и контроля селекта
  const messageForSelectDepartments = t?.messageForSelectDepartments || 'Выберите дирекцию';
  const departmentsControl = useOptionsLoader(
    formData,
    setFormData,
    ['departmentId'],
    'directorateId',
    initDepartmentOptionsFromServer,
    messageForSelectDepartments
  );

  //отслеживаем выполнение запроса
  useSuccessListener(setFormData, initialFormData, closeModal);

  // запрашиваем файлы для создания массива опций
  useEffect(() => {
    return () => {
      dispatch(initOptionsFromServer());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CustomContainer>
      <CustomTitle
        titleText={t?.deviceIssuanceTitle || 'ВЫДАЧА В ЭКСПЛУАТАЦИЮ УСТРОЙСТВА'}
        deviceType={currentDevice.type}
        deviceId={currentDevice.id}
      />
      <FormContainer>
        <DateSelector
          column="left"
          width="100%"
          height="var(--sadr-font-size-60)"
          label={t?.labelIssueDate || 'Дата выдачи в эксплуатацию *'}
          placeholder={t?.placeholderSelectDate || 'Выберите дату'}
          selectedDate={formData.date}
          setSelectedDate={(date) => handleUniversalChange(formData, setFormData, null, 'date', date, 'date')}
          name="date"
          minDate={convertToDate(currentDevice?.lastActionDate)}
          maxDate={new Date()}
        />
        <FilePicker
          column="left"
          label={t?.labelAcceptanceCert || 'Акт приема-передачи *'}
          formData={formData}
          setFormData={setFormData}
          fieldName="acceptanceCertName"
          fieldIdName="acceptanceCert"
          rowSpan={2}
        />
        <Checkbox
          id="station-location"
          column="left"
          label={t?.stationaryPlacementCB || 'Стационарное размещение'}
          onChange={handleChangeCheckbox}
          height={`var(--sadr-font-size-50)`}
          margin="var(--sadr-font-size-20) 0px var(--sadr-font-size-5)"
        />
        {isVisible && (
          <Input
            column="left"
            isVisible={isVisible}
            onChange={(event) => handleUniversalChange(formData, setFormData, event)}
            label={t?.driverPersonnelNumberLbl || 'Табельный № машиниста'}
            placeholder={t?.driverPersonnelNumberPH || 'Введите табельный номер'}
            width="100%"
            height="var(--sadr-font-size-60)"
            value={formData.responsibleId}
            name="responsibleId"
            maxLength={10}
            isCoordinate={true}
            isAllowed={undefined}
          />
        )}
        {!isVisible && (
          <Selector
            column="left"
            isVisible={!isVisible}
            options={optionsForSelect?.trainTypes}
            onChange={(selectedOption) => {
              handleUniversalChange(formData, setFormData, null, 'trainTypeId', selectedOption, 'select');
            }}
            label={t?.rollingStockTypeLbl || 'Тип подвижного состава'}
            placeholder={t?.rollingStockTypePH || 'Выберите тип подвижного состава'}
            width="100%"
            height="var(--sadr-font-size-60)"
            value={
              formData.trainTypeId
                ? optionsForSelect?.trainTypes?.find((option) => option.value === formData.trainTypeId)
                : null
            }
            isMulti={false}
            name="trainTypeId"
          />
        )}
        <Selector
          column="right"
          options={roads}
          onChange={(selectedOption) => {
            handleUniversalChange(formData, setFormData, null, 'roadId', selectedOption, 'select');
          }}
          label={`${t?.labelRoad} *` || 'Дорога *'}
          placeholder={t?.placeholderRoad || 'Выберите дорогу'}
          width="100%"
          height="var(--sadr-font-size-60)"
          value={formData.roadId ? roads?.find((option) => option.label === formData.roadId) : null}
          isMulti={false}
          name="roadId"
        />
        <Selector
          column="right"
          options={optionsForSelect?.directoratesUipps}
          onChange={(selectedOption) => {
            handleUniversalChange(formData, setFormData, null, 'directorateId', selectedOption, 'select');
          }}
          label={`${t?.labelDirectorate} *` || 'Дирекция *'}
          placeholder={t?.placeholderDirectorate || 'Выберите дирекцию'}
          width="100%"
          height="var(--sadr-font-size-60)"
          value={
            formData.directorateId
              ? optionsForSelect?.directoratesUipps?.find((option) => option.value === formData.directorateId)
              : null
          }
          isMulti={false}
          name="directorateId"
          isDisabled={directoratesControl?.isSelectorDisabled}
          message={directoratesControl?.message}
          customClick={directoratesControl?.onSelectorChange}
        />
        <Selector
          column="right"
          options={departments}
          onChange={(selectedOption) => {
            handleUniversalChange(formData, setFormData, null, 'departmentId', selectedOption, 'select');
          }}
          label={`${t?.labelDepartment} *` || 'Подразделение *'}
          placeholder={t?.placeholderSelectDepartment || 'Выберите подразделение'}
          width="100%"
          height="var(--sadr-font-size-60)"
          value={formData.departmentId ? departments?.find((option) => option.value === formData.departmentId) : null}
          isMulti={false}
          name="departmentId"
          isDisabled={departmentsControl?.isSelectorDisabled}
          message={departmentsControl?.message}
          customClick={departmentsControl?.onSelectorChange}
          rowSpan={2}
        />
        {isVisible && (
          <Input
            column="right"
            isVisible={isVisible}
            onChange={(event) => handleUniversalChange(formData, setFormData, event)}
            label={t?.driverContactsLbl || 'Контакты машиниста'}
            placeholder={t?.driverContactsPH || 'Введите контакты'}
            width="100%"
            height="var(--sadr-font-size-60)"
            value={formData.responsibleContact}
            name="responsibleContact"
            maxLength={10}
          />
        )}
        {!isVisible && (
          <Input
            column="right"
            isVisible={!isVisible}
            onChange={(event) => handleUniversalChange(formData, setFormData, event)}
            label={t?.rollingStockNumberLbl || 'Номер подвижного состава'}
            placeholder={t?.rollingStockNumberPH || 'Введите № подвижного состава'}
            width="100%"
            height="var(--sadr-font-size-60)"
            value={formData.trainNumber}
            name="trainNumber"
            maxLength={10}
          />
        )}
      </FormContainer>
      <CustomButton
        onClick={(event) => {
          handlerSubmit(event);
        }}
        width="var(--sadr-font-size-420)"
        height="var(--sadr-font-size-60)"
        text={t?.issueDeviceButton || 'Выдать устройство'}
        disabled={isButtonDisabled}
        isButton
      />
    </CustomContainer>
  );
}

export default TransferUippsToUsage;
